<div mat-dialog-title color="primary" class="title">If you leave now, changes you made will not be saved.</div>

<div mat-dialog-actions>
  <button mat-button class="button" (click)="cancel()">Cancel</button>
  <button mat-button class="verify-button" (click)="confirm()" cdkFocusInitial>Leave Without Saving</button>
</div>